import { getAPICall, patchAPICall, postAPICall } from "./apiCall";

export const saveNewGRN = (data) => {
  return postAPICall("hierarchical-insert", { body: [data] });
};